import { render, staticRenderFns } from "./PresentationOfferAttachmentsDialog.vue?vue&type=template&id=56acc200"
import script from "./PresentationOfferAttachmentsDialog.vue?vue&type=script&lang=js"
export * from "./PresentationOfferAttachmentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports